import { ReactNode } from "react"
import Header from "./Header"
import Footer from "./Footer"
import ProfileReminder from "../ui/ProfileReminder"
import AddressConfirmModal from "../ui/AddressConfirmModal"

interface LayoutProps {
  children: ReactNode
  className?: string
}

const Layout = ({ children, className = "" }: LayoutProps) => {
  return (
    <div
      className={`min-h-screen overflow-x-hidden bg-[radial-gradient(circle_at_15%_20%,hsl(var(--primary)/0.14),transparent_42%),radial-gradient(circle_at_85%_0%,hsl(var(--accent)/0.12),transparent_35%),linear-gradient(180deg,hsl(var(--background)),hsl(var(--background)))] flex flex-col ${className}`}
    >
      <Header />
      <main className="container mx-auto px-2 py-4 flex-1">{children}</main>
      <ProfileReminder />
      <AddressConfirmModal />
      <Footer />
    </div>
  )
}

export default Layout
